var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "div",
        { staticClass: "form-wrapper" },
        [
          _vm.checkBtn
            ? _c("el-card", { staticClass: "employees-card-bottom" }, [
                _c(
                  "div",
                  [
                    _c("formBox", {
                      ref: "formBox",
                      attrs: { total: _vm.total },
                      on: {
                        confirmData: _vm.confirmData,
                        openAssessed: _vm.openAssessed,
                        getExportData: _vm.getExportData,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                      },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.tableData,
                              "row-key": "id",
                              height: _vm.tableHeight,
                              "default-expand-all": "",
                              "tree-props": { children: "children" },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "test.name",
                                label: _vm.$t("access.examinee"),
                                "min-width": "100",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "frame.name",
                                label: _vm.$t("user.work.department"),
                                "min-width": "120",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: _vm.$t("user.work.assessmentname"),
                                "min-width": "100",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "period",
                                label: _vm.$t("toptable.assessmentcycle"),
                                "min-width": "100",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$refs.formBox.getPeriodText(
                                                scope.row.period
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2526315561
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "score",
                                label: _vm.$t("user.work.qssessmentscore"),
                                "min-width": "80",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "level",
                                label: _vm.$t("access.assessmentgrade"),
                                "min-width": "80",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "check.name",
                                label: _vm.$t("user.work.assessor"),
                                "min-width": "80",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "status",
                                label: _vm.$t("hr.assessmentstatus"),
                                "min-width": "80",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$refs.formBox.getStatusText(
                                                scope.row.status
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1077675209
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "id",
                                label: _vm.$t("access.assessmenttime"),
                                "min-width": "150",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("p", { staticClass: "p-time" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("access.start")) +
                                                "："
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm
                                                  .$moment(scope.row.start_time)
                                                  .format("yyyy-MM-DD")
                                              ) +
                                              "\n                "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "p-time" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("access.end")) +
                                                "："
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm
                                                  .$moment(scope.row.end_time)
                                                  .format("yyyy-MM-DD")
                                              ) +
                                              "\n                "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3839308304
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "address",
                                label: _vm.$t("public.operation"),
                                fixed: "right",
                                width: "180",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "hr:assessStaff:assessmentStaff:edit",
                                                ],
                                                expression:
                                                  "['hr:assessStaff:assessmentStaff:edit']",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.changeStaff(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "hr:assessStaff:assessmentStaff:delete",
                                                ],
                                                expression:
                                                  "['hr:assessStaff:assessmentStaff:delete']",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDelete(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("public.delete"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        scope.row.status == 3 ||
                                        scope.row.status == 4
                                          ? _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "hasPermi",
                                                    rawName: "v-hasPermi",
                                                    value: [
                                                      "hr:assessStaff:assessmentStaff:record",
                                                    ],
                                                    expression:
                                                      "['hr:assessStaff:assessmentStaff:record']",
                                                  },
                                                ],
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleScore(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("评分记录")]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3497589346
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "page-fixed" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "page-size": _vm.where.limit,
                                "current-page": _vm.where.page,
                                "page-sizes": [15, 20, 30],
                                layout:
                                  "total,sizes, prev, pager, next, jumper",
                                total: _vm.total,
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.pageChange,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("export-excel", {
            ref: "exportExcel",
            attrs: {
              template: false,
              "save-name": _vm.saveName,
              "export-data": _vm.exportData,
            },
          }),
          _vm._v(" "),
          _c("score-dialog", {
            ref: "scoreDialog",
            attrs: { config: _vm.config },
          }),
          _vm._v(" "),
          _c("notAssessed", { ref: "sssessed" }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.checkBtn
        ? _c("auditProcess", {
            ref: "auditProcess",
            attrs: {
              id: _vm.id,
              strType: "check",
              "process-index": _vm.status,
            },
            on: { auditProcess: _vm.auditProcess },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }